module.exports = __webpack_public_path__ + "static/shape-a6927260315cd3ee990b8d968d2cee59.png";